
riot.tag2('import-products-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Импорт (Шаг 1 из 2)</div>\n    </yield>\n    <yield to="body">\n      <loader text="Импорт" indeterminate="true" if="{loader}"></loader>\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.filename}">\n          <div class="input-group">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onchange="{changeFile}">\n                <input name="file" type="file" accept=".xlsx, .csv"><i class="fa fa-fw fa-folder-open text-primary"></i>\n              </div>\n            </div>\n            <input class="form-control" name="filename" value="{item.filename}" placeholder="Выберите файл или введите ссылку" __disabled="{file.files.length}">\n            <div class="input-group-btn">\n              <div class="btn-file btn btn-default" onclick="{clear}" title="Сброс"><i class="fa fa-fw fa-close text-danger"></i></div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-6 col-xs-12">\n            <div class="form-group">\n              <label class="control-label">Профиль загрузки</label>\n              <div class="input-group">\n                <select class="form-control" name="uploadProfile" value="{item.uploadProfile}" onchange="{uploadProfileChange}">\n                  <option each="{i in uploadProfiles}" value="{i.name}" __selected="{i.name == parent.item.uploadProfile}" no-reorder>{i.title}</option>\n                </select>\n                <div class="input-group-btn">\n                  <div class="btn-file btn btn-default" onclick="{deleteProfile}" title="Удалить выбранный профиль" placeholder="Выберите файл или введите ссылку"><i class="fa fa-fw fa-close text-danger"></i></div>\n                </div>\n              </div>\n            </div>\n\n\n\n\n\n\n\n            <div class="form-group">\n              <label class="control-label">Разделитель столбцов</label>\n              <select class="form-control" id="delimId" name="delimiter" value="{item.delimiter}">\n                <option each="{i in delimiters}" value="{i.name}" __selected="{i.name == parent.item.delimiter}" no-reorder>{i.title}</option>\n              </select>\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12">\n\n\n\n\n\n\n\n            <div class="form-group">\n              <label class="control-label">Пропустить строк</label>\n              <input class="form-control" name="skip" min="0" step="1" value="{item.skip}" type="{\'number\'}">\n            </div>\n            <div class="form-group">\n              <label class="control-label">Ограничитель поля</label>\n              <input class="form-control" id="limFId" name="limiterField" value="{item.limiterField}">\n            </div>\n          </div>\n          <div class="col-md-6 col-xs-12" if="{parent.opts.idGroup}">\n            <div class="form-group">\n              <label></label>\n              <input type="checkbox" id="inGroup" name="inGroup" __checked="{item.inGroup}">Разместить в выбранную группу\n            </div>\n          </div>\n          <div class="help-block">{error.filename}</div>\n        </div>\n\n\n      </form>\n      <div id="terminalImport" style="width: 100%; margin-top: 20px; color: #a94442;"></div>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button" __disabled="{cannotBeClosed}">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.submit}" type="button" __disabled="{cannotBeClosed}">Продолжить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;
self.loader = true;

// ВКЛ
self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    // нужно получать профили из браузера
    var profiles = JSON.parse(localStorage.getItem("profiles")); // отсутствуют - null

    // поля селектора профиля загрузки,
    // значение при отсутствии записей в браузере
    modal.uploadProfiles = [{ name: 'profile1', title: 'Профиль 1' }];

    // загружаем профили из браузера
    if (profiles == null) {
        var profiles = {};
    } else {
        modal.uploadProfiles = [];
        for (var key in profiles) {
            if (key != 'groupNow') {
                var profileUnit = { name: key, title: profiles[key]['title'] };
                modal.uploadProfiles.push(profileUnit);
            }
        }
    }

    /*// ... кодировки
    modal.encodings = [
        {name: 'utf-8',         title: 'UTF-8'},
        {name: 'windows-1251',  title: 'Windows-1251'}
    ]*/

    // ... разделителителя столбцов
    modal.delimiters = [{ name: 'auto', title: 'Автоопределение' }, { name: ';', title: 'Точка с запятой' }, { name: ',', title: 'Запятая' }, { name: '\t', title: 'Табуляция' }];

    // ... ключевое поле
    modal.keyFields = [{ name: 'article', title: 'Артикул' }, { name: 'id', title: 'Идентификатор' }, { name: 'code', title: 'Код (URL)' }, { name: 'name', title: 'Наименование' }];

    // значния по умолчанию
    modal.error = false;
    modal.mixin('validation');
    modal.mixin('change');

    // получаем настройки последнего профиля или по умолчанию
    if ((0, _keys2.default)(profiles).length != 0) {

        var uploadProfileValue = profiles['groupNow'];
        if (profiles != undefined && uploadProfileValue != undefined) {

            if (profiles[uploadProfileValue]['title'] != undefined) {
                var titleValue = profiles[uploadProfileValue]['title'];
            } else {
                var titleValue = undefined;
            }

            if (profiles[uploadProfileValue]['delimiter'] != undefined) {
                var delimiterValue = profiles[uploadProfileValue]['delimiter'];
            } else {
                var delimiterValue = modal.delimiters[0]['name'];
            }

            if (profiles[uploadProfileValue]['keyField'] != undefined) {
                var keyFieldValue = profiles[uploadProfileValue]['keyField'];
            } else {
                var keyFieldValue = modal.keyFields[0]['name'];
            }

            if (profiles[uploadProfileValue]['limiterField'] != undefined) {
                var limiterFieldValue = profiles[uploadProfileValue]['limiterField'];
            } else {
                var limiterFieldValue = '"';
            }

            if (profiles[uploadProfileValue]['skip'] != undefined) {
                var skipValue = profiles[uploadProfileValue]['skip'];
            } else {
                var skipValue = 1;
            }

            if (profiles[uploadProfileValue]['margins'] != undefined) {
                var marginsValue = profiles[uploadProfileValue]['margins'];
            } else {
                var marginsValue = undefined;
            }
        } else {
            var uploadProfileValue = modal.uploadProfiles[0]['name'];
            var titleValue = modal.uploadProfiles[0]['title'];
            var delimiterValue = modal.delimiters[0]['name'];
            var keyFieldValue = modal.keyFields[0]['name'];
            var limiterFieldValue = '"';
            var skipValue = 1;
            var marginsValue = undefined;
        }
    } else {
        var uploadProfileValue = modal.uploadProfiles[0]['name'];
        var titleValue = modal.uploadProfiles[0]['title'];
        var delimiterValue = modal.delimiters[0]['name'];
        var keyFieldValue = modal.keyFields[0]['name'];
        var limiterFieldValue = '"';
        var skipValue = 1;
        var marginsValue = undefined;
    }

    modal.item = {
        filename: '',
        type: '0',
        reset: false,

        uploadProfile: uploadProfileValue,
        title: titleValue,
        /*encoding      : modal.encodings[0]['name'],*/
        delimiter: delimiterValue,
        keyField: keyFieldValue,
        limiterField: limiterFieldValue,
        skip: skipValue,

        margins: marginsValue
    };

    modal.rules = {
        filename: {
            required: true,
            rules: [{
                type: 'url',
                prompt: 'Выберите файл или введите правильную ссылку'
            }]
        }
    };

    modal.loader = false;
    modal.changeFile = function (e) {
        modal.item.filename = e.target.files[0].name;
        modal.update();

        /** блокировка полей для не CSV */
        if (modal.item.filename.indexOf(".csv") + 1 != 0) {
            document.getElementById("delimId").disabled = false;
            document.getElementById("limFId").disabled = false;
        } else {
            document.getElementById("delimId").disabled = true;
            document.getElementById("limFId").disabled = true;
        }
    };

    modal.clear = function () {
        modal.item.filename = '';
        modal.item.file = '';
        modal.file.value = '';
    };

    // после изменения
    modal.afterChange = function (e) {
        if (modal.file.files && !modal.file.files.length) {
            var name = e.target.name;
            delete modal.error[name];
            modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
        }

        if (modal.file.files && modal.file.files.length) modal.error = false;

        if (modal.item && modal.item.type == 0) modal.item.reset = false;

        delete modal.item.file;
    };

    // загрузка измененного профиля
    modal.uploadProfileChange = function (e) {
        var prof = JSON.parse(localStorage.getItem("profiles"));
        if (prof != null) profiles = prof;

        // parseInt()
        modal.item.uploadProfile = e.target.value;
        modal.item.title = profiles[modal.item.uploadProfile]['title'];
        modal.item.delimiter = profiles[modal.item.uploadProfile]['delimiter'];
        modal.item.keyField = profiles[modal.item.uploadProfile]['keyField'];
        modal.item.limiterField = profiles[modal.item.uploadProfile]['limiterField'];
        modal.item.skip = parseInt(profiles[modal.item.uploadProfile]['skip']);
        modal.item.margins = profiles[modal.item.uploadProfile]['margins'];
        modal.update();
    };

    // удаление профиля
    modal.deleteProfile = function (e) {
        // получаем данные из брауз
        var prof = JSON.parse(localStorage.getItem("profiles"));
        if (prof != null) profiles = prof;

        // удаление проф
        if ((0, _keys2.default)(profiles).length != 0) {
            delete profiles[modal.item.uploadProfile];
            profiles['groupNow'] = 'profile1';

            // запись
            var serialProfiles = (0, _stringify2.default)(profiles);
            localStorage.setItem('profiles', serialProfiles);

            modal.uploadProfiles = [];
            for (var key in profiles) {
                if (key != 'groupNow') {
                    var _profileUnit = { name: key, title: profiles[key]['title'] };
                    modal.uploadProfiles.push(_profileUnit);
                }
            }
            delete modal.item.margins;
            modal.update();
        }
    };
});

// ОТПРАВИТЬ
self.submit = function () {
    var modal = self.tags['bs-modal'];
    var formData = new FormData();
    var target = modal.file;
    modal.loader = true;

    //formData.append('type', modal.item.type)
    //formData.append('reset', modal.item.reset)
    formData.append('prepare', true);

    if (target.files.length) {
        for (var i = 0; i < target.files.length; i++) {
            formData.append('file' + i, target.files[i], target.files[i].name);
        }
    } else {
        formData.append('url', modal.item.filename);
        modal.error = modal.validation.validate(modal.item, modal.rules);
        if (modal.error) return;
    }
    // прикрепляем к отправке параметры
    var idGroup = 0;
    if (modal.item.inGroup) {
        idGroup = opts.idGroup;
    }
    formData.append('uploadProfile', modal.item.uploadProfile);
    /*formData.append('encoding', modal.item.encoding)*/
    formData.append('delimiter', modal.item.delimiter);
    formData.append('keyField', modal.item.keyField);
    formData.append('limiterField', modal.item.limiterField);
    formData.append('skip', parseInt(modal.item.skip));
    formData.append('idGroup', idGroup);

    // получаем настройки по профилям из браузера
    var profiles = JSON.parse(localStorage.getItem("profiles")); // отсутствуют - null

    // если настройки не совподают или их нет - добаить новый профиль
    // (если нет параметра - перезаписывается в профиль)
    var create = true;
    if (profiles == null) {
        var profiles = {};
    } else if ((0, _keys2.default)(profiles).length == 1) {
        var create = false;
    } else {
        for (var key in profiles) {
            if (modal.item.delimiter == profiles[key]['delimiter'] && modal.item.keyField == profiles[key]['keyField'] && modal.item.limiterField == profiles[key]['limiterField']
            //- modal.item.skip         == profiles[key]['skip']  // отступ менятеся внутри профиля
            ) {
                    var create = false;
                    break;
                }
        }
    }

    if (create == true) {
        // генерируем новый профиль

        // получаем список имен профилей - генерируем новое название
        var numProfiles = 1;
        var stop = false;
        while (stop == false) {
            var array_in_presence = false;

            // проверяем наличие имени в списке
            for (var key in profiles) {
                if ('profile' + numProfiles == key) {
                    array_in_presence = true;
                    break;
                }
            }

            // нет - присваивае к newNameProfile, останавливаем перебор
            // есть - поднимаем номер, продолжаем перебор
            if (array_in_presence == false) {
                var newNameProfile = 'profile' + numProfiles;
                var newTitleProfile = '\u041F\u0440\u043E\u0444\u0438\u043B\u044C ' + numProfiles;
                stop = true;
            } else numProfiles += 1;
        }
    } else {
        // редактируем старый профиль
        var newNameProfile = modal.item.uploadProfile;
        var newTitleProfile = modal.item.title;
    }

    // собираем данные
    var newProfileSettings = {
        'title': newTitleProfile,
        'delimiter': modal.item.delimiter,
        'keyField': modal.item.keyField,
        'limiterField': modal.item.limiterField,
        'skip': parseInt(modal.item.skip),

        'margins': modal.item.margins
    };

    // добавляем в массив и возвращаем браузеру
    profiles[newNameProfile] = newProfileSettings;
    profiles['groupNow'] = newNameProfile;

    var serialProfiles = (0, _stringify2.default)(profiles);
    localStorage.setItem('profiles', serialProfiles);

    modal.uploadProfiles = [];
    for (var key in profiles) {
        if (key != 'groupNow') {
            var profileUnit = { name: key, title: profiles[key]['title'] };
            modal.uploadProfiles.push(profileUnit);
        }
    }
    modal.update();

    //- } else {
    //-     // добавляем в массив выбранный профиль
    //-     profiles['groupNow'] = modal.item.uploadProfile
    //-
    //-     var serialProfiles = JSON.stringify(profiles)
    //-     localStorage.setItem('profiles', serialProfiles)
    //- }
    //-
    //- modal.loader = true
    //- modal.cannotBeClosed = true
    //- modal.update()

    // ЗАГРУЗИТЬ
    // данные уходят в Product.php post
    // по файлу - $items, по настройкам - $_POST

    API.upload({
        object: 'Product',
        data: formData,
        success: function success(response) {
            console.log(response);
            if (response.errors == '') {
                var dataI = response;
                dataI.filename = modal.item.filename;
                dataI.uploadProfile = modal.item.uploadProfile;
                localStorage.setItem('shop24_import_products', (0, _stringify2.default)(dataI));
                var items = JSON.parse(localStorage.getItem('shop24_import_products') || '{}');
                modal.modalHide();
                observable.trigger('products-imports');
            }

            var elemT = document.getElementById("terminalImport");
            elemT.innerHTML = response.errors;
        },
        complete: function complete() {
            modal.loader = false;
            modal.cannotBeClosed = false;
            modal.update();
        }
    });
};
});


// WEBPACK FOOTER //
// ./modals/import-products-modal.tag